module.exports = __webpack_public_path__ + "img/aire-acondicionado.81f6da94.svg";